<template>
    <div>
        <div class="Breadcrumb">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item><a href="/">首页</a></el-breadcrumb-item>
                <el-breadcrumb-item v-if="classify == 'information'">政策信息</el-breadcrumb-item>
                <el-breadcrumb-item v-else>公告公示</el-breadcrumb-item>
                <el-breadcrumb-item>详情</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="detail">
            <h1>{{ newdetail.TITLE }}</h1>
            <p>日期：{{ newdetail.DATE }}</p>
            <div v-html="newdetail.CONTENT" class="content"></div>
          </div>
    </div>
</template>

<script>
export default {
    name: "NewDetail",
    props: {
        id: String,
        classify: String,
        page: String
    }, 
    methods:{
        getInformation(){
            let category = this.classify == 'information' ? '政策信息' : '公告公示';
            if(this.page){
                this.$axios.post('/api/Book/UrlList',{
                    category: category,
                    page: this.page,
                    count:15
                }).then(res => {
                    console.log(res.data);
                    if(this.classify == 'information'){
                        this.newdetail = res.data.政策信息[this.id];
                    }
                    else if(this.classify == 'notice'){
                        this.newdetail = res.data.公告公示[this.id];
                    }
                })
            }
            else{
                this.$axios.get('/api/Book/BookIndex').then(res=>{
                    console.log(res.data);
                    if(this.classify == 'information'){
                        this.newdetail = res.data.政策信息[this.id];
                    }
                    else if(this.classify == 'notice'){
                        this.newdetail = res.data.公告公示[this.id];
                    }
                })
            }
                
            }
    },
    data(){
        return{
            newdetail: {}
        }
    },
    created(){
        this.getInformation();
    }
}
</script>             

<style scoped>
.content{
    margin-top: 20px;
    width: 1300px;
    margin-left: 50px;
    margin-bottom: 20px;
    text-align: left;
}
.detail p{
    font-size: 20px;
    color: #3c3c3c;
    margin-top: 20px;
    width: 1300px;
    margin-left: 50px;
    background-color: #e0e0e0;
    margin-bottom: 20px;
}
.detail h1{
    font-size: 30px;
    color: #3c3c3c;
    margin-top: 20px;
}
.detail{
    width: 1400px;
    height: 100%;
    margin-left: 250px;
    margin-top: 30px;
    float: left;
    text-align: center;
    border: rgb(63, 142, 231) 1px solid;
}
.el-breadcrumb{
    margin-top: 20px;
    margin-left: 270px;
    height: 60px;
    font-size: 16px;
    color: #c1c6c9;
    float: left;
}
.Breadcrumb{
    width: 1903px;
    height: 60px;
    background: #f5f6f6;
    margin-left: -20px;
    float: left;
}
</style>